import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertCircle, Smartphone } from "lucide-react";

const ForgotCodeModal = ({ open, onOpenChange }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-slate-800 border-slate-700 text-white max-w-md" data-testid="forgot-code-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-amber-400">
            <AlertCircle className="w-5 h-5" />
            Code et identifiant oublié
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <p className="text-slate-300">
            Si vous avez oublié votre code PIN ou votre identifiant, veuillez contacter :
          </p>
          <div className="bg-slate-900/50 p-4 rounded-lg space-y-2">
            <p className="text-white font-medium">L'Administrateur ou la Responsable Op. & Log</p>
            <p className="text-amber-400 flex items-center gap-2">
              <Smartphone className="w-4 h-4" />
              +229 01 4147 0000
            </p>
          </div>
          <p className="text-slate-400 text-sm">
            Ils pourront vous communiquer vos identifiants ou réinitialiser votre code PIN.
          </p>
        </div>
        <Button
          onClick={() => onOpenChange(false)}
          className="w-full bg-amber-500 hover:bg-amber-600"
          data-testid="forgot-code-close-btn"
        >
          Compris
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default ForgotCodeModal;
